import api from '../../plugins/api';

// Данные владельца комиссионного авто (Freedom, п.4.1 схемы).
// Обязательный шаг перед подтверждением перерегистрации для типов THRIFT*:
// банк сверяет ИИН с базой МВД по VIN и шлёт владельцу СМС для согласия на продажу.
const ffinAddOwner = ({ appealId, iin, mobilePhone }) => {
  return api.post('/api/bank/ffin/owner', { appealId, iin, mobilePhone });
};

export default ffinAddOwner;
